import type { FunctionComponent, ReactNode } from 'react';

import { NavLink } from '@dr.pogodin/react-utils';

import './style.scss';

type PropsT = {
  children: ReactNode;
  to: string;
};

const Item: FunctionComponent<PropsT> = ({ children, to }) => (
  <NavLink end styleName="container" to={to}>
    {children}
  </NavLink>
);

export default Item;
